/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddEmployeeAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddEmployeeAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/AddEmployee/AddEmployeeAction"
  
}) {
let selectedStageIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stage_ids',
})
let selectedEmployeeIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'employee_ids',
})
let aggregateData = fromHelpers.isValid(selectedStageIdsValueData, selectedEmployeeIdsValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 marginTop={24}
 type="primary"
 size="normal"
 data="selected.stage_ids"
 data="selected.employee_ids"
 aggregate="helpers.js isValid"
 disabled={aggregateData}
 text="Subscribe"
/>
{children}
</React.Fragment>)
}